import PATH from 'constants/basePath';

/**
 * Os monitoramentos de terceiros (RD Station, Google Tag Manager) cobrem apenas
 * o e-commerce (venda de passagens), nunca o back-office (/bdos) ou os demais
 * módulos servidos no mesmo domínio.
 */
export const isTicketSalesTrackedPath = (pathname: string) => {
  const base = PATH.TICKET_RESERVATION_WEBSITE.BASE_URL;
  return pathname === base || pathname.startsWith(`${base}/`);
};
